import { useState } from 'react';
import { GetVendorsAdvanceSearchAPI } from '../../../../../../Services';
import { VendorsMapper } from '../../../VendorsUtilities';
import { useDebouncedAction } from '../../../../../../Hooks/DebouncedAction';

export const useFetchVendors = () => {
  const [vendors, setVendors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const getVendorsAdvanceSearch = useDebouncedAction(async (search) => {
    setIsLoading(true);
    const body = {
      criteria: !!search
        ? {
            'vendor_name.name': [
              {
                searchType: 2,
                value: search,
              },
            ],
          }
        : {},
      filterBy: 'createdOn',
      orderBy: 2,
    };
    const res = await GetVendorsAdvanceSearchAPI(
      { pageSize: 50, pageIndex: 0 },
      body
    );
    if (!(res && res.status && res.status !== 200)) {
      setVendors(
        res.result.map((item) => VendorsMapper(item, item?.vendor?.vendor))
      );
    }
    setIsLoading(false);
  });

  return { vendors, isLoading, getVendorsAdvanceSearch };
};
